module.exports = __webpack_public_path__ + "img/gh-36020____-26.prt.2a862434.jpg";